import { LogErrors } from './../LogErrors'
//import { useLanguage } from './../LanguageContext' // Importa el hook

//Funciones comunes
import { ValidatePassword, ValidateSqlInjection } from './Security'

import { Login as BLLogin } from './../BL/Sessions'


/**
 * Función que valida los datos ingresados, realiza el login, y devuelve resultados.
 * @param {Object} formData Información del formulario { user, password, remember }
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const Login = async (formData) => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto

    try {
        // Validación de los datos del formulario
        const errors = {}
        //const regex = /^[a-záéíóúüñ0-9 ]+$/ <-- Se puede llegar a usar
        const regex = /^[a-z0-9]+$/
        
        if (formData.user) {
            if (!regex.test(formData.user.toLowerCase())) {
                errors.user = 'El usuario contiene caracteres inválidos'
                //errors.user = translate('errorMessages.login.user.invalidCharacter')
            } else if (await ValidateSqlInjection(formData.user)) {
                errors.user = 'El usuario que escribiste es inválido'
            }
        } else {
            errors.user = 'El usuario es obligatorio'
        }
        
        const passwordError = await ValidatePassword(formData.password)

        if (passwordError) {
            errors.password = passwordError
        }

        // Si hay errores, retornar inmediatamente
        if (Object.keys(errors).length > 0) {
            return { success: false, errors }
        }

        // Llamar a la capa de datos para autenticar al usuario
        const response = await BLLogin(formData.user, formData.password)
        
        if (response.success) {
            return { success: true, data: response.data } // Retornar la respuesta exitosa
        } else {
            // Manejar errores del backend (por ejemplo, credenciales incorrectas)
            return { success: false, errors: { general: response.message } }
        }
    } catch (error) {
        await LogErrors('Logins BL', error)
        return { success: false, errors: { general: error || 'Ocurrió un error inesperado' } }
    }
}

/**
 * Función que busca y valida parámetro que indica si se le cerró la sesión al usuario (sin que él lo haya hecho)
 * @param {*} search 
 * @returns 
 */
const ShowLogoutMessage = (search) => {
    try {
        const urlParams = new URLSearchParams(search)

        if (urlParams.size === 0) {
            return { success: false, message: '' }
        }

        const logoutParameter = urlParams.get('logout') // null si no existe

        if (!logoutParameter) {
            return { success: false, message: '' }
        }
        
        // Valida solo letras/números de 18 chars
        const isLogout = /^[a-z0-9]{18}$/.test(logoutParameter.toLowerCase())

        if (isLogout) {
            return { success: true, data: null }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        
    }
}

export { Login, ShowLogoutMessage };